import packageJSON from "../../package.json";
import { Link, useNavigate, Navigate, NavLink } from "react-router-dom";
import styled from "styled-components";
import Button from "./Button";

import "./layout.css";
import LayoutContext, { LayoutProvider } from "../context/layoutContext";
import { useContext, useEffect, useState } from "react";
import { Avatar, Badge, FloatButton, Menu, MenuProps, Popover, Typography, message } from "antd";
import { Dropdown, Space } from 'antd';
import { AlertOutlined, ContainerFilled, GoldenFilled, HomeFilled, MailOutlined, MenuOutlined, ProductFilled, ShopOutlined, ShoppingCartOutlined, SmileFilled, ToolOutlined, UserOutlined } from "@ant-design/icons";
import { getCartItems, getUser } from "../helpers";
import StoreContext from "../context/storeContext";
import { UserContext } from "../context/userContext";
import { PoweredDetails } from "../pages/dashboard/Dashboard";
import moment from "moment";
const { Text, Title } = Typography;


const Topbar = styled.div`
    width: 100%;
    background-color: white;
    padding: 0rem;
    padding-bottom:0;
    border-right: 1px solid #dedede;
    display: flex;
    align-items:center;
    justify-content:space-between;
`

const Sidebar = styled.div`
    max-width: 200px;
    width:200px;
    min-width:200px;
    min-height: 100vh;
    padding: 2rem 0.5rem;
    background-color: #202947;
    transition: 0.4s ease;
    @media (max-width: 767px) {
        position: fixed;
        z-index: 2;
        border-right: 1px solid red;
        transform: translateX(-100%);
    }
`


const NavItem = styled.div`
padding: 10px;
    border:0px solid black;
    
`

const NavItemText = styled.span`
    // color: rgba(255,255,255,0.7);
    color:#b2b8c7;
    font-size: 14px;
    font-weight: 400;
`

const LogoutButton = styled.button`
    background-color: red;
`

const ProfilePicture = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 25px;
    background-color: #cecece;
    margin-right: 15px;
    margin-left: 30px;
`

type MenuItem = Required<MenuProps>['items'][number];

const items = [
    {
        label: 'Ballina',
        key: 'dashboard',
        icon: <HomeFilled />,
        roles: ['Admin', 'Manager', 'User']
    },
    {
        label: 'Produktet',
        key: 'articles',
        icon: <ProductFilled />,
        roles: ['Admin', 'Manager', 'User']
    },
    {
        label: 'Brendet',
        key: 'brands',
        icon: <GoldenFilled />,
        // roles: ['Admin']
        roles: ['Admin']
    },
    {
        label: 'Kategorite',
        key: 'categories',
        icon: <GoldenFilled />,
        // roles: ['Admin']
        roles: ['Admin']
    },
    {
        label: 'Pikat shitese',
        key: 'stores',
        icon: <ShopOutlined />,
        // roles: ['Admin']
        roles: ['Admin']
    },
    {
        label: 'Porositë',
        key: 'orders',
        icon: <ContainerFilled color="white" />,
        // roles: ['Admin', 'User']
        roles: ['Admin', 'Manager', "User"]
    },
    {
        label: 'Përdoruesit',
        key: 'users',
        icon: <UserOutlined />,
        // roles: ['Admin']
        roles: ['Admin']
    },
    {
        label: 'Promocionet',
        key: 'promotions',
        icon: <AlertOutlined />,
        // roles: ['Admin']
        roles: ['Admin']
    },
    {
        label: 'Menaxhim',
        key: 'tools',
        icon: <ToolOutlined />,
        // roles: ['Admin']
        roles: ['Admin']
    },
];

const itemsOther = [
    // {
    //     label: "Profili",
    //     key: '0',
    //     type: null,
    // },
    {
        label: "Dil jasht",
        key: '1',
        type: null,
    }
];




const Layout = ({ children: page }) => {

    const navigate = useNavigate();
    const { cart, emptyCart } = useContext(StoreContext)
    const { sidebarToggled, handleSidebar, role } = useContext(LayoutContext);
    const [messageApi, contextHolder] = message.useMessage();
    const { user, logout } = useContext(UserContext);

    const [sidebarItems, setSidebarItems] = useState([]);

    const handleLogout = () => {
        logout(navigate);
    };


    const handleMenuClick = (e) => {
        console.log(e.key)
        if (e.key == 0) {
            // navigate(`/profile`);
            navigate("/users/new", { state: { user: user } });
        }
        if (e.key == 1) {
            handleLogout();
        }
    }

    const profileDropdown = () => {
        return (
            <Dropdown.Button menu={{ items: itemsOther, onClick: handleMenuClick }} onClick={() => navigate("/profile", { state: { user: user } })} placement="bottom" icon={<UserOutlined />}>
                {user?.user?.fullName}
            </Dropdown.Button>
        )
    }



    useEffect(() => {
        console.log("user", user)

        const filteredItems = items?.filter((item) => item.roles.includes(user?.details?.roleName));
        setSidebarItems(filteredItems);

    }, [user])

    return (

        <div style={{ minHeight: "100vh" }}>
            {contextHolder}
            <Topbar style={{ padding: "10px", paddingTop: 10, paddingBottom: 10 }}>
                <div className="container-fluid" style={{ width: "100%" }}>
                    <div className="d-flex justify-content-between">
                        <img src={`https://ardhmeria-ks.com/b2b/assets/Ardhmeria_emblem.png`} className="header-logo" />
                        <div className="d-flex align-items-center">

                            <Badge count={cart?.length} style={{ marginRight: 20 }}>

                                <Avatar shape="square" style={{ backgroundColor: "#1677ff", width: 40, height: 30, marginRight: 10, cursor: "pointer" }} size="small" onClick={() => navigate("/cart")}>
                                    <ShoppingCartOutlined />
                                </Avatar>


                            </Badge>

                            {profileDropdown()}



                            <FloatButton icon={<MenuOutlined />} className="menu-toggler" onClick={() => {
                                handleSidebar(!sidebarToggled)

                            }} />

                        </div>
                    </div>

                </div>
            </Topbar>
            {/* <Topbar className={sidebarToggled && "open"} style={{ borderStyle: "solid", borderTopWidth: 1, borderBottomWidth: 1, borderColor: "#e2dddd" }}>
                <div className="container">
                    <Menu onClick={(onClick)} selectedKeys={[current]} mode="horizontal" items={items} />

                </div>

            </Topbar> */}
            <div className="d-flex">
                <Sidebar style={sidebarToggled ? { transform: 'translateX(0)' } : {}}>

                    {sidebarItems && sidebarItems.map((item) => (
                        <NavLink to={`${item?.key}`} onClick={() => handleSidebar(false)}>
                            <NavItem className="mb-2 sidebar-item">

                                <div className="d-flex align-items-center">
                                    {/* <i className='d-block bx bx-home-alt-2' style={{ fontSize: "1.2rem" }}></i> */}
                                    {item?.icon}
                                    <NavItemText style={{ marginLeft: 20 }}>{item?.label}</NavItemText>
                                </div>

                            </NavItem>
                        </NavLink>
                    ))}





                </Sidebar>
                <div className="content-container" style={{ width: "100%", flex: 1, minWidth: 0, backgroundColor: "#F9F9FA" }}>

                    {page}
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="mt-4 d-flex justify-content-between">
                                    <p style={{ textTransform: "uppercase" }}>© Te drejtat e rezervuara <a style={{ display: "inline" }} href="https://ardhmeria-ks.com">Ardhmeria</a> {moment().format("YYYY")} • v {packageJSON?.version}</p>

                                    <Popover content={PoweredDetails} title="Kontakt" trigger="hover">
                                        <p style={{ color: "rgb(196, 196, 196)" }}>Zhvilluar nga  <a style={{ display: "inline" }} href="tel:+38349318505">Delvin Krasniqi</a></p>
                                    </Popover>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

        </div>

    )
}

export default Layout;